import {
  put, takeLatest, all, takeEvery,
} from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import BusyIntegrationActions, { busyIntegrationActionTypes } from '../../actions/integrations/busyIntegrationAction';
import BusyIntegrationServices from '../../services/integrations/busyIntegrationServices';

function* _getBusyConnections(action) {
  try {
    const {
      orgId, callback,
    } = action;
    yield put(BusyIntegrationActions.getBusyConnectionsLoading(true));
    const linkedBusyAccounts = yield BusyIntegrationServices.getBusyConnections(orgId);
    if (linkedBusyAccounts.success) {
      if (callback) {
        yield put(BusyIntegrationActions.getBusyConnectionsSuccess(linkedBusyAccounts?.result));
        callback(linkedBusyAccounts.result);
      }
      yield put(BusyIntegrationActions.getBusyConnectionsSuccess(linkedBusyAccounts?.result));
    }
    yield put(BusyIntegrationActions.getBusyConnectionsLoading(false));
  } catch (error) {
    yield put(BusyIntegrationActions.getBusyConnectionsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(busyIntegrationActionTypes.GET_BUSY_CONNECTIONS.ERROR, error));
  }
}

/**
 *
 */
function* getBusyConnections() {
  yield takeLatest(busyIntegrationActionTypes.GET_BUSY_CONNECTIONS.REQUEST, _getBusyConnections);
}

// delete busy connection
function* _deleteBusyConnection(action) {
  try {
    const {
      payload, callback,
    } = action;
    yield put(BusyIntegrationActions.deleteBusyConnectionLoading(true));
    const deleteBusyConnectionResponse = yield BusyIntegrationServices.deleteBusyConnection(payload);
    if (deleteBusyConnectionResponse.success) {
      notification.open({
        type: 'success',
        message: 'Busy connection deleted successfully',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback(deleteBusyConnectionResponse.result);
      }
      yield put(BusyIntegrationActions.deleteBusyConnectionLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: deleteBusyConnectionResponse.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(BusyIntegrationActions.deleteBusyConnectionLoading(false));
  } catch (error) {
    yield put(BusyIntegrationActions.deleteBusyConnectionLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(busyIntegrationActionTypes.DELETE_BUSY_CONNECTION.ERROR, error));
  }
}

function* deleteBusyConnection() {
  yield takeLatest(busyIntegrationActionTypes.DELETE_BUSY_CONNECTION.REQUEST, _deleteBusyConnection);
}

// connect to busy
function* _connectToBusy(action) {
  try {
    const {
      payload, callback,
    } = action;
    yield put(BusyIntegrationActions.connectToBusyLoading(true));
    const connectToBusyResponse = yield BusyIntegrationServices.connectToBusy(payload);
    if (connectToBusyResponse.success) {
      if (callback) {
        callback();
      }
      notification.open({
        type: 'success',
        message: 'Your Busy account connection has been initiated.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: connectToBusyResponse.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(BusyIntegrationActions.connectToBusyLoading(false));
  } catch (error) {
    yield put(BusyIntegrationActions.connectToBusyLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(busyIntegrationActionTypes.CONNECT_TO_BUSY.ERROR, error));
  }
}

function* connectToBusy() {
  yield takeLatest(busyIntegrationActionTypes.CONNECT_TO_BUSY.REQUEST, _connectToBusy);
}

// sync busy product
function* _syncProduct(action) {
  try {
    const {
      payload, callback,
    } = action;
    yield put(BusyIntegrationActions.syncProductLoading(true));
    const syncProductResponse = yield BusyIntegrationServices.syncProduct(payload);
    if (syncProductResponse.success) {
      notification.open({
        type: 'success',
        message: 'Product synced successfully',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback(syncProductResponse.result);
      }
      yield put(BusyIntegrationActions.syncProductLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: syncProductResponse.message,
        duration: 4,
        placement: 'top',
      });
    }
  } catch (error) {
    yield put(BusyIntegrationActions.syncProductLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(busyIntegrationActionTypes.SYNC_BUSY_PRODUCT.ERROR, error));
  }
}

function* syncProduct() {
  yield takeLatest(busyIntegrationActionTypes.SYNC_BUSY_PRODUCT.REQUEST, _syncProduct);
}

// sync busy customer
function* _syncVendor(action) {
  try {
    const {
      payload, callback,
    } = action;
    yield put(BusyIntegrationActions.syncVendorLoading(true));
    const syncVendorResponse = yield BusyIntegrationServices.syncVendor(payload);
    if (syncVendorResponse.success) {
      notification.open({
        type: 'success',
        message: 'Customer synced successfully',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback(syncVendorResponse.result);
      }
      yield put(BusyIntegrationActions.syncVendorLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: syncVendorResponse.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(BusyIntegrationActions.syncVendorLoading(false));
  } catch (error) {
    yield put(BusyIntegrationActions.syncVendorLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(busyIntegrationActionTypes.SYNC_BUSY_CUSTOMER.ERROR, error));
  }
}

function* syncVendor() {
  yield takeLatest(busyIntegrationActionTypes.SYNC_BUSY_CUSTOMER.REQUEST, _syncVendor);
}

// refresh busy connection
function* _refreshBusyConnection(action) {
  try {
    const {
      payload, callback,
    } = action;
    yield put(BusyIntegrationActions.refreshBusyConnectionsLoading(true));
    const refreshBusyConnectionResponse = yield BusyIntegrationServices.refreshBusyConnection(payload);
    if (refreshBusyConnectionResponse.success) {
      notification.open({
        type: 'success',
        message: 'Busy connection refreshed successfully',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback(refreshBusyConnectionResponse.result);
      }
      yield put(BusyIntegrationActions.refreshBusyConnectionsLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: refreshBusyConnectionResponse.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(BusyIntegrationActions.refreshBusyConnectionsLoading(false));
  } catch (error) {
    yield put(BusyIntegrationActions.refreshBusyConnectionsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(busyIntegrationActionTypes.REFRESH_BUSY_CONNECTIONS.ERROR, error));
  }
}

function* refreshBusyConnection() {
  yield takeLatest(busyIntegrationActionTypes.REFRESH_BUSY_CONNECTIONS.REQUEST, _refreshBusyConnection);
}

// Busy Location connection

function* _connectToBusyLocation(action) {
  try {
    const {
      payload, callback,
    } = action;
    yield put(BusyIntegrationActions.connectToBusyLocationLoading(true));
    const connectToBusyLocationResponse = yield BusyIntegrationServices.connectToBusyLocation(payload);
    if (connectToBusyLocationResponse.success) {
      if (callback) {
        callback(connectToBusyLocationResponse.result);
      }
    }
    yield put(BusyIntegrationActions.connectToBusyLocationLoading(false));
  } catch (error) {
    yield put(BusyIntegrationActions.connectToBusyLocationLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(busyIntegrationActionTypes.CONNECT_TO_BUSY_LOCATION.ERROR, error));
  }
}

function* connectToBusyLocation() {
  yield takeLatest(busyIntegrationActionTypes.CONNECT_TO_BUSY_LOCATION.REQUEST, _connectToBusyLocation);
}

// push grn to busy
function* _pushGrnToBusy(action) {
  try {
    const {
      payload, callback,
    } = action;
    yield put(BusyIntegrationActions.pushGrnToBusyLoading(true));
    const pushGrnToBusyResponse = yield BusyIntegrationServices.pushGrnToBusy(payload);
    if (pushGrnToBusyResponse.success) {
      notification.open({
        type: 'success',
        message: 'GRN pushed to Busy',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback(pushGrnToBusyResponse.result);
      }
      yield put(BusyIntegrationActions.pushGrnToBusyLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: pushGrnToBusyResponse.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(BusyIntegrationActions.pushGrnToBusyLoading(false));
  } catch (error) {
    yield put(BusyIntegrationActions.pushGrnToBusyLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* pushGrnToBusy() {
  yield takeLatest(busyIntegrationActionTypes.PUSH_GRN_TO_BUSY.REQUEST, _pushGrnToBusy);
}

// push invoice to busy
function* _pushInvoiceToBusy(action) {
  try {
    const {
      payload, callback,
    } = action;
    yield put(BusyIntegrationActions.pushInvoiceToBusyLoading(true));
    const pushInvoiceToBusyResponse = yield BusyIntegrationServices.pushInvoiceToBusy(payload);
    if (pushInvoiceToBusyResponse.success) {
      notification.open({
        type: 'success',
        message: 'Invoice pushed to Busy',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback(pushInvoiceToBusyResponse.result);
      }
      yield put(BusyIntegrationActions.pushInvoiceToBusyLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: pushInvoiceToBusyResponse.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(BusyIntegrationActions.pushInvoiceToBusyLoading(false));
  } catch (error) {
    yield put(BusyIntegrationActions.pushInvoiceToBusyLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* pushInvoiceToBusy() {
  yield takeLatest(busyIntegrationActionTypes.PUSH_INVOICE_TO_BUSY.REQUEST, _pushInvoiceToBusy);
}

// push expense to busy

function* _pushExpenseToBusy(action) {
  try {
    const {
      payload, callback,
    } = action;
    yield put(BusyIntegrationActions.pushExpenseToBusyLoading(true));
    const pushExpenseToBusyResponse = yield BusyIntegrationServices.pushExpenseToBusy(payload);
    if (pushExpenseToBusyResponse.success) {
      notification.open({
        type: 'success',
        message: 'Expense pushed to Busy',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback(pushExpenseToBusyResponse.result);
      }
      yield put(BusyIntegrationActions.pushExpenseToBusyLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: pushExpenseToBusyResponse?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(BusyIntegrationActions.pushExpenseToBusyLoading(false));
  } catch (error) {
    yield put(BusyIntegrationActions.pushExpenseToBusyLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* pushExpenseToBusy() {
  yield takeLatest(busyIntegrationActionTypes.PUSH_EXPENSE_TO_BUSY.REQUEST, _pushExpenseToBusy);
}

// push credit note to busy

function* _pushCreditNoteToBusy(action) {
  try {
    const {
      payload, callback,
    } = action;
    yield put(BusyIntegrationActions.pushCreditNoteToBusyLoading(true));
    const pushCreditNoteToBusyResponse = yield BusyIntegrationServices.pushCreditNoteToBusy(payload);
    if (pushCreditNoteToBusyResponse.success) {
      notification.open({
        type: 'success',
        message: 'Credit Note pushed to Busy',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback(pushCreditNoteToBusyResponse.result);
      }
      yield put(BusyIntegrationActions.pushCreditNoteToBusyLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: pushCreditNoteToBusyResponse.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(BusyIntegrationActions.pushCreditNoteToBusyLoading(false));
  } catch (error) {
    yield put(BusyIntegrationActions.pushCreditNoteToBusyLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* pushCreditNoteToBusy() {
  yield takeLatest(busyIntegrationActionTypes.PUSH_CREDIT_NOTE_TO_BUSY.REQUEST, _pushCreditNoteToBusy);
}

// push debit note to busy

function* _pushDebitNoteToBusy(action) {
  try {
    const {
      payload, callback,
    } = action;
    yield put(BusyIntegrationActions.pushDebitNoteToBusyLoading(true));
    const pushDebitNoteToBusyResponse = yield BusyIntegrationServices.pushDebitNoteToBusy(payload);
    if (pushDebitNoteToBusyResponse.success) {
      notification.open({
        type: 'success',
        message: 'Debit Note pushed to Busy',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback(pushDebitNoteToBusyResponse.result);
      }
      yield put(BusyIntegrationActions.pushDebitNoteToBusyLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: pushDebitNoteToBusyResponse.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(BusyIntegrationActions.pushDebitNoteToBusyLoading(false));
  } catch (error) {
    yield put(BusyIntegrationActions.pushDebitNoteToBusyLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* pushDebitNoteToBusy() {
  yield takeLatest(busyIntegrationActionTypes.PUSH_DEBIT_NOTE_TO_BUSY.REQUEST, _pushDebitNoteToBusy);
}

export default function* busyIntegrationSaga() {
  yield all([
    getBusyConnections(),
    deleteBusyConnection(),
    connectToBusy(),
    syncProduct(),
    syncVendor(),
    refreshBusyConnection(),
    connectToBusyLocation(),
    pushGrnToBusy(),
    pushInvoiceToBusy(),
    pushExpenseToBusy(),
    pushCreditNoteToBusy(),
    pushDebitNoteToBusy(),
  ]);
}
